export default __webpack_public_path__ + "static/media/coxhealth-logo.4b6f89c8.png";